import React from 'react';
import PropTypes from 'prop-types';

import Theme from '../../theme';
import { LoadingModal } from '../../ui';
import { Button } from '../../components';

const PrivacyListFooter = ({
    t,
    listType,
    isPrivate,
    isLoading,
    openAddPartnerModal,
}) => {
    return (
        <LoadingModal isLoading={isLoading} style={{ paddingVertical: 5 }} />
    );
}

PrivacyListFooter.propTypes = {
    t: PropTypes.func.isRequired,
    openAddPartnerModal: PropTypes.func,
    isLoading: PropTypes.bool.isRequired,
    isPrivate: PropTypes.bool.isRequired,
    listType: PropTypes.oneOf(['whitelist', 'blacklist', 'searchlist']).isRequired,
};

export default PrivacyListFooter;
